<template>
  <v-row class="ma-0 auth-row">
    <v-col
      cols="12"
      md="5"
      class="ma-0 pa-0 d-none d-md-flex auth-panel-col"
    >
      <aside class="auth-panel">
        <header class="auth-panel__brand">
          <img src="/scrapingant-logo.png" alt="ScrapingAnt" />
          <span class="auth-panel__wordmark">ScrapingAnt</span>
        </header>

        <div class="auth-panel__content">
          <p v-if="$slots.eyebrow" class="auth-panel__eyebrow">
            <slot name="eyebrow" />
          </p>
          <h1 class="auth-panel__headline">
            <slot name="headline" />
          </h1>
          <p v-if="$slots.subhead" class="auth-panel__subhead">
            <slot name="subhead" />
          </p>

          <ul v-if="$slots.features" class="auth-panel__features">
            <slot name="features" />
          </ul>
        </div>

        <footer v-if="$slots.footnote" class="auth-panel__footnote">
          <slot name="footnote" />
        </footer>

        <img
          src="/auth/ant-mark.svg"
          alt=""
          aria-hidden="true"
          class="auth-panel__mark"
        />
      </aside>
    </v-col>

    <v-col cols="12" md="7" class="ma-0 pa-0 auth-form-col">
      <div class="auth-form-wrapper">
        <div v-if="$slots.mobileBanner" class="auth-mobile-banner d-md-none">
          <slot name="mobileBanner" />
        </div>
        <slot name="form" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AuthLayout",
};
</script>

<style scoped lang="scss">
.auth-row {
  min-height: 100vh;
}

.auth-panel-col {
  min-height: 100vh;
}

.auth-panel {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 56px 56px 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #ffffff;
  background-image: url("/auth/bg-gradient.svg");
  background-size: cover;
  background-position: center;
  overflow: hidden;

  &__brand {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    z-index: 2;

    img {
      width: 32px;
      height: 32px;
    }
  }

  &__wordmark {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.01em;
    color: #ffffff;
  }

  &__content {
    position: relative;
    z-index: 2;
    max-width: 460px;
  }

  &__eyebrow {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 16px;
  }

  &__headline {
    font-size: 34px;
    line-height: 1.15;
    font-weight: 600;
    margin: 0 0 16px;
    color: #ffffff;
  }

  &__subhead {
    font-size: 15px;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.82);
    margin: 0 0 32px;
    max-width: 420px;
  }

  &__features {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  &__footnote {
    position: relative;
    z-index: 2;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);
    max-width: 460px;

    a {
      color: rgba(255, 255, 255, 0.92);
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  &__mark {
    position: absolute;
    right: -20px;
    bottom: -20px;
    width: 260px;
    height: 260px;
    opacity: 0.08;
    pointer-events: none;
    z-index: 1;
  }
}

.auth-form-col {
  background-color: #f7f7f7;
  min-height: 100vh;
}

.auth-form-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.auth-mobile-banner {
  width: 100%;
  max-width: 480px;
  margin-bottom: 24px;
  padding: 20px 24px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0f172a 0%, #1e1b2e 60%, #e2782f 140%);
  color: #ffffff;
}

@media (max-width: 960px) {
  .auth-form-wrapper {
    padding: 32px 16px;
  }
}
</style>
